import { useMemo } from "react";
import useAuth from "./useAuth";

export const useUserId = () => {
    const state = useAuth((state) => ({
        account_user: state.account_user,
        tokens: state.tokens,
    }));
    return useMemo(() => {
        const prodAccountId = Object.keys(state.tokens).find((k) =>
            k.startsWith("P"),
        );
        if (prodAccountId) {
            const prodAccount = state.account_user.accounts.find(
                (a) => a.account_id === prodAccountId,
            );
            if (prodAccount) {
                return prodAccount.user.id;
            }
        }
        return "";
    }, [state]);
};
